import { analyticsKeys, track } from '@mobi/account/Utils'
import { DepositLimitFrequency } from '@mobi/api-types/index'

export type SignupEvent = {
  interaction_type:
    | 'Sign Up Clicked'
    | 'Sign Up Started'
    | 'Name & DOB'
    | 'Confirm Address'
    | 'Contact Details'
    | 'Mobile Number Verification Success'
    | 'Risk Questions Success'
    | 'Select ID Option'
    | 'ID Verification Success'
    | 'Sign Up Complete'
    | 'Set Deposit Limit'
    | 'Deposit Now'
    | 'Go Back to Home Page'
    | 'Need Assistance'
    | 'Sign Up Error'
    | 'Sign Up Failed'
    | 'Already Have Account'
    | 'Account Protection'
    | 'Account Protection Skipped'
    | 'Drivers License Info'
    | 'Login Failed'
  location:
    | 'Header'
    | 'Login Modal'
    | 'Hamburger'
    | 'Sign Up'
    | 'Sign Up Failed'
    | 'Additional Information'
    | 'Bet Slip'
    | undefined
  message: string | undefined
  addressMethod: 'auto' | 'manual' | undefined
  depositFrequency: DepositLimitFrequency | undefined
  limitAmount: string | undefined
  marketingConsent: boolean | undefined
  offer_available: boolean | undefined
  signUpStarted: boolean | undefined
  optionSelected: string | undefined
  attemptNumber: string | undefined
  signUpFlow: 'Standard' | 'ID Verification' | undefined
  alias: boolean | undefined
  bioState: boolean | undefined
  mfaState: boolean | undefined
  mobileNumberVerifySkipped: boolean | undefined
  isVerified: boolean | undefined
  isAccountPending: boolean | undefined
}

export type SignupTrackerEvent = { interaction_type: SignupEvent['interaction_type'] } & Partial<
  Omit<SignupEvent, 'interaction_type'>
>

const initValues: Omit<SignupEvent, 'interaction_type'> = {
  location: undefined,
  message: undefined,
  addressMethod: undefined,
  limitAmount: undefined,
  marketingConsent: undefined,
  offer_available: undefined,
  signUpStarted: undefined,
  optionSelected: undefined,
  attemptNumber: undefined,
  signUpFlow: undefined,
  alias: undefined,
  bioState: undefined,
  mfaState: undefined,
  mobileNumberVerifySkipped: undefined,
  depositFrequency: undefined,
  isVerified: undefined,
  isAccountPending: undefined,
}

export const signupTracker = (event: SignupTrackerEvent) =>
  track(analyticsKeys.signup, { ...initValues, ...event })
